/* eslint-disable new-cap */
/* eslint-disable no-undef */
(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('ReportsUserEventsController', reportsUserEventsController)

  reportsUserEventsController.inject = ['$rootScope', '$http', 'NotificationService', 'ReportUserEventsService', 'EventService', 'UserService', 'ngTableParams']

  function reportsUserEventsController ($rootScope, $http, NotificationService, ReportUserEventsService, EventService, UserService, ngTableParams) {
    var vm = this

    vm.download = download
    vm.isNotOnOffEvent = isNotOnOffEvent
    vm.getUserEvents = getUserEvents
    vm.eventSearched = null

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    }

    loadData()

    function loadData () {
      EventService
        .getByBelongsTo({ 'belongs_to': 'user_events' })
        .$promise
        .then(function (data) {
          vm.events = data
        })
        .catch(function () {
          NotificationService.errorHandler('', $rootScope.labels.requestError)
        })
      UserService
        .getUsersByRoles([0, 1])
        .$promise
        .then(function (data) {
          vm.users = data
        })
        .catch(function () {
          NotificationService.errorHandler('', $rootScope.labels.requestError)
        })
    }

    function getUserEvents () {
      if (validateFields()) {
        vm.eventSearched = vm.filters.event
        vm.userEventsTable = new ngTableParams({
          page: 1,
          count: 25
        }, {
          getData: function ($defer, params) {
            vm.filters.page = params.url().page
            ReportUserEventsService
              .getUserEvents(vm.filters)
              .$promise
              .then(function (data) {
                if (data.success) {
                  vm.show = true
                  $defer.resolve(data.page)
                  params.total(data.total)
                  vm.total = data.total
                } else {
                  vm.show = false
                  vm.userEventsTable = false
                  NotificationService.warningHandler(data, data.message)
                }
              })
              .catch(function () {
                NotificationService.errorHandler('', $rootScope.labels.errorReport)
              })
          }
        })
      }
    }

    function download () {
      if (validateFields()) {
        $http.get(apiUrl + '/reports/user-events/download', { params: vm.filters })
          .then(function ({ data }) {
            if (data.warning) {
              NotificationService.warningHandler(data, data.message)
              return
            }
            const success = prepareFileForDownload(data)
            if (!success) {
              NotificationService.warningHandler(data, $rootScope.labels.noRegisters)
            }
          }, function ({ data }) {
            NotificationService.errorHandler(data, $rootScope.labels.errorReport)
          })
      }
    }

    function prepareFileForDownload (data) {
      let component = angular.element('<a/>')
      component.css({ display: 'none' })
      angular.element(document.body).append(component)

      let blob = new Blob([data], { type: 'text/csv' })

      if (blob.size <= 42) {
        return false
      }

      let csvUrl = URL.createObjectURL(blob)

      component.attr({
        href: csvUrl,
        target: '_self',
        download: 'user-events.csv'
      })[0].click()

      component.remove()
      URL.revokeObjectURL(csvUrl)

      return true
    }

    function dateSelected (type, date) {
      if (type === 'from') {
        vm.pkadayToDate.setMinDate(date)
      }
      if (type === 'to') {
        vm.pkadayFromDate.setMaxDate(date)
      }
    }

    function validateFields () {
      var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY')
      var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY')
      if (toDate < fromDate) {
        NotificationService.warningHandler('', $rootScope.labels.invalidInitialDate)
        vm.show = false
        vm.userEventsTable = false
        return false
      }
      if (toDate.diff(fromDate, 'days') > 30) {
        vm.show = false
        vm.userEventsTable = false
        NotificationService.warningHandler('', $rootScope.labels.dateMore30Days)
        return false
      }
      if (vm.filters.event === null || vm.filters.event === undefined) {
        vm.show = false
        vm.userEventsTable = false
        NotificationService.warningHandler('', $rootScope.labels.selectAnAction)
        return false
      }
      return true
    }

    function isNotOnOffEvent () {
      let found = vm.events.find(element => element._id === vm.eventSearched)

      if (found && found.label === 'CLICK_ON_OFF_BUTTON') {
        return false
      }

      return true
    }
  }
  // eslint-disable-next-line semi
})();
